import React, { createContext, useContext, useState, useEffect } from 'react';

// Define membership tiers directly in context to ensure they're always available
const STATIC_MEMBERSHIP_TIERS = {
  TIER1: {
    id: 'tier1',
    name: 'Tier 1',
    price: 75,
    priceId: 'price_tier1_annual',
    description: 'Analysts & Associates with less than three years of experience (also referred to as recent undergraduates).',
    features: [],
    duration: 'annual'
  },
  TIER2: {
    id: 'tier2',
    name: 'Tier 2',
    price: 125,
    priceId: 'price_tier2_annual',
    description: 'Analysts & Associates with more than three years of experience.',
    features: [],
    duration: 'annual'
  },
  TIER3: {
    id: 'tier3',
    name: 'Tier 3',
    price: 175,
    priceId: 'price_tier3_annual',
    description: 'Managers, VP\'s, Directors, and Managing Directors.',
    features: [],
    duration: 'annual'
  },
  TIER4: {
    id: 'tier4',
    name: 'Tier 4',
    price: 225,
    priceId: 'price_tier4_annual',
    description: 'C-suite Executives, Principals, Partners, and Business Owners.',
    features: [],
    duration: 'annual'
  },
  TIERUSV: {
    id: 'tierUSV',
    name: 'Tier USV',
    price: 75,
    priceId: 'price_tierUSV_annual',
    description: 'US Veterans, regardless of seniority level.',
    features: [],
    duration: 'annual'
  }
};

const MembershipContext = createContext();

export const useMembership = () => {
  const context = useContext(MembershipContext);
  if (!context) {
    throw new Error('useMembership must be used within a MembershipProvider');
  }
  return context;
};

export const MembershipProvider = ({ children }) => {
  const [membershipTiers, setMembershipTiers] = useState(STATIC_MEMBERSHIP_TIERS);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Ensure tiers are always loaded
    console.log('MembershipProvider: Initializing tiers');
    console.log('Available tiers:', Object.keys(STATIC_MEMBERSHIP_TIERS));
    setMembershipTiers(STATIC_MEMBERSHIP_TIERS);
    setIsLoaded(true);
  }, []);

  const value = {
    membershipTiers,
    isLoaded,
    getTier: (tierKey) => membershipTiers[tierKey],
    getAllTiers: () => membershipTiers,
    getTierKeys: () => Object.keys(membershipTiers)
  };

  return (
    <MembershipContext.Provider value={value}>
      {children}
    </MembershipContext.Provider>
  );
};

export default MembershipContext;
